import React from 'react';

import get from 'lodash.get';
import { Translate } from 'react-redux-i18n';

import { isArrayWithItems } from '../../../helpers/arrayHelper';

import { ViewTable } from '../../../components/layouts/viewTable';
import { DonationGiftMatchingItem } from './components/donationGiftMatchingItem';

export const DonationGiftMatchingInformation = (props) => {
  const { giftMatching } = props.donation;
  const { isShowEmptyFields } = props;

  const entries = get(giftMatching, 'entries', []);

  // Don't render if no gift matching data
  if (!giftMatching || !isArrayWithItems(entries)) {
    return null;
  }

  return (
    <React.Fragment>
      <div className="donation-gift-matching-information">
        <ViewTable
          title={
            <Translate value="donation.donation-view.donation-details.gift-matching" />
          }
        >
          <div className="view-details-content">
            {React.Children.toArray(
              entries.map((entry, index) => (
                <DonationGiftMatchingItem key={index} entry={entry} />
              ))
            )}
          </div>
        </ViewTable>
      </div>
    </React.Fragment>
  );
};
